import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Logo } from "./Logo";

export const Footer = () => {
  const { copy } = useLanguage();
  return (
    <footer className="bg-pine-dark text-linen/90" data-testid="main-footer">
      <div className="max-w-6xl mx-auto px-5 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <Logo className="h-9 w-9" dark />
            <span className="font-serif font-semibold text-lg text-linen">Gusto <span className="italic text-gold">y</span> Ciencia</span>
          </div>
          <p className="text-sm text-linen/70 font-serif italic">{copy.footer.tagline}</p>
        </div>
        <div>
          <h3 className="text-xs font-mono uppercase tracking-widest text-gold mb-4">{copy.footer.contact}</h3>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><Phone size={14} className="text-gold" /><a href="tel:+34613234203" data-testid="footer-phone" className="hover:text-gold transition-colors">+34 613 23 42 03</a></li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-gold" /><a href="mailto:hola@gustoyciencia.com" data-testid="footer-email" className="hover:text-gold transition-colors">hola@gustoyciencia.com</a></li>
            <li className="flex items-center gap-2"><MapPin size={14} className="text-gold" /><span>Valencia, España · Online</span></li>
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-mono uppercase tracking-widest text-gold mb-4">{copy.footer.legal}</h3>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/privacidad" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">{copy.footer.privacy}</Link></li>
            <li><Link to="/cookies" data-testid="footer-cookies-link" className="hover:text-gold transition-colors">{copy.footer.cookies}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-linen/10">
        <p className="max-w-6xl mx-auto px-5 py-5 text-xs text-linen/60 leading-relaxed" data-testid="footer-disclaimer">{copy.disclaimer}</p>
        <p className="max-w-6xl mx-auto px-5 pb-6 text-xs text-linen/40">© {new Date().getFullYear()} Gusto y Ciencia. {copy.footer.rights}</p>
      </div>
    </footer>
  );
};
